import React from "react";
import { Button } from "../../components/ButtonElement/Button";
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  Img,
  ImgWrap,
  ActivityListWrapper,
  ActivityListContainer,
  ActivityList,
  ActivityListHeading,
  ActivityListItem,
  ActivityListItemSpan,
} from "./InfoElements";

const InfoSection = ({
  lightBg,
  id,
  imgStart,
  lightText,
  darkText,
  headline,
  description,
  img,
  alt,
  activity,
  activitiesTwo,
  topLine,
  buttonLabel,
  primary,
  dark,
  dark2,
}) => {
  return (
    <>
      <InfoContainer lightBg={lightBg}>
        <InfoWrapper id={id}>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <Heading lightText={lightText}>{headline}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                {activity && (
                  <>
                    <ActivityListContainer>
                      <ActivityListWrapper>
                        <ActivityListHeading>
                          Proiectele noastre
                        </ActivityListHeading>
                        <ActivityList>
                          {activity.map((item) => (
                            <ActivityListItem key={item.id}>
                              <ActivityListItemSpan>
                                {item.icon}
                              </ActivityListItemSpan>{" "}
                              {item.details}
                            </ActivityListItem>
                          ))}
                        </ActivityList>
                      </ActivityListWrapper>
                      <ActivityListWrapper>
                        <ActivityListHeading>
                          Activitati extracurriculare
                        </ActivityListHeading>
                        <ActivityList>
                          {activitiesTwo.map((item) => (
                            <ActivityListItem key={item.id}>
                              <ActivityListItemSpan>
                                {item.icon}
                              </ActivityListItemSpan>{" "}
                              {item.details}
                            </ActivityListItem>
                          ))}
                        </ActivityList>
                      </ActivityListWrapper>
                    </ActivityListContainer>
                  </>
                )}
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
